import FloatingVue from 'floating-vue'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      customTip: {
        $resetCss: true,
        triggers: ['hover'],
        autoHide: true,
        placement: 'top',
        distance: 15,
        $extend: 'tooltip',
      },
    },
  })
})
